import { useState } from 'react'

import { Mouth } from './calendar'
import { HolidayList } from './holyDays'
import { useHistory } from 'react-router-dom/'
import { HiArrowSmallLeft } from 'react-icons/hi2'

import { FormattedMessage } from 'react-intl'

const countries = ['Argentina', 'Brasil', 'Chile', 'Costa Rica', 'Colombia', 'Peru', 'Mexico', 'Venezuela', 'Ecuador']

const holiDays = {
	Argentina: {
		2024: [
			{ date: '12/8', title: 'Inmaculada Concepción' },
			{ date: '12/25', title: 'Navidad' },
		],
		2025: [
			{ date: '1/1', title: 'Año Nuevo' },
			{ date: '2/16', title: 'Carnaval' },
			{ date: '2/17', title: 'Carnaval' },
			{ date: '3/24', title: 'Día de la Memoria por la Verdad y la Justicia' },
			{ date: '4/2', title: 'Día del Veterano y de los Caídos en la Guerra de Malvinas' },
			{ date: '4/18', title: 'Viernes Santo' },
			{ date: '4/20', title: 'Día de la Pascua' },
			{ date: '5/1', title: 'Día del Trabajo' },
			{ date: '5/25', title: 'Revolución de Mayo' },
			{ date: '6/20', title: 'Día de la Bandera' },
			{ date: '7/9', title: 'Día de la Independencia' },
			{ date: '10/12', title: 'Día de la Diversidad Cultural' },
			{ date: '11/20', title: 'Día de la Soberanía Nacional' },
			{ date: '12/8', title: 'Inmaculada Concepción' },
			{ date: '12/25', title: 'Navidad' },
		],
	},
	Brasil: {
		2024: [
			{ date: '11/20', title: 'Dia da Consciência Negra' },
			{ date: '12/25', title: 'Natal' },
		],
		2025: [
			{ date: '1/1', title: 'Ano Novo' },
			{ date: '3/4', title: 'Carnaval' },
			{ date: '4/18', title: 'Sexta-feira Santa' },
			{ date: '4/20', title: 'Páscoa' },
			{ date: '4/21', title: 'Tiradentes' },
			{ date: '5/1', title: 'Dia do Trabalho' },
			{ date: '6/19', title: 'Corpus Christi' },
			{ date: '9/7', title: 'Independência do Brasil' },
			{ date: '10/12', title: 'Nossa Senhora Aparecida' },
			{ date: '11/2', title: 'Finados' },
			{ date: '11/15', title: 'Proclamação da República' },
			{ date: '11/20', title: 'Dia da Consciência Negra' },
			{ date: '12/25', title: 'Natal' },
		],
	},
	Chile: {
		2024: [
			{ date: '12/25', title: 'Navidad' },
			{ date: '12/8', title: 'Inmaculada Concepción' },
		],
		2025: [
			{ date: '1/1', title: 'Año Nuevo' },
			{ date: '4/20', title: 'Día de la Pascua' },
			{ date: '5/1', title: 'Día del Trabajo' },
			{ date: '9/18', title: 'Fiestas Patrias (Independência)' },
			{ date: '9/19', title: 'Día de las Glorias del Ejército' },
			{ date: '10/12', title: 'Día del Descubrimiento de América' },
			{ date: '11/2', title: 'Día de Todos los Santos' },
			{ date: '12/8', title: 'Inmaculada Concepción' },
			{ date: '12/25', title: 'Navidad' },
		],
	},
	Colombia: {
		2024: [
			{ date: '12/25', title: 'Navidad' },
			{ date: '12/8', title: 'Inmaculada Concepción' },
		],
		2025: [
			{ date: '1/1', title: 'Año Nuevo' },
			{ date: '4/17', title: 'Jueves Santo' },
			{ date: '4/18', title: 'Viernes Santo' },
			{ date: '4/20', title: 'Día de la Pascua' },
			{ date: '5/1', title: 'Día del Trabajo' },
			{ date: '6/2', title: 'Corpus Christi' },
			{ date: '6/9', title: 'Sagrado Corazón de Jesús' },
			{ date: '7/20', title: 'Día de la Independencia' },
			{ date: '8/7', title: 'Batalla de Boyacá' },
			{ date: '10/12', title: 'Día de la Raza' },
			{ date: '11/3', title: 'Día de Todos los Santos' },
			{ date: '11/17', title: 'Independencia de Cartagena' },
			{ date: '12/8', title: 'Inmaculada Concepción' },
			{ date: '12/25', title: 'Navidad' },
		],
	},
	Peru: {
		2024: [
			{ date: '12/8', title: 'Inmaculada Concepción' },
			{ date: '12/25', title: 'Navidad' },
		],
		2025: [
			{ date: '1/1', title: 'Año Nuevo' },
			{ date: '4/9', title: 'Miércoles Santo' },
			{ date: '4/11', title: 'Viernes Santo' },
			{ date: '4/13', title: 'Día de la Pascua' },
			{ date: '5/1', title: 'Día del Trabajo' },
			{ date: '7/28', title: 'Independencia' },
			{ date: '7/29', title: 'Independencia' },
			{ date: '12/8', title: 'Inmaculada Concepción' },
			{ date: '12/25', title: 'Navidad' },
		],
	},
	Mexico: {
		2024: [{ date: '12/25', title: 'Navidad' }],
		2025: [
			{ date: '1/1', title: 'Año Nuevo' },
			{ date: '4/9', title: 'Jueves Santo' },
			{ date: '4/10', title: 'Viernes Santo' },
			{ date: '4/12', title: 'Día de la Pascua' },
			{ date: '5/1', title: 'Día del Trabajo' },
			{ date: '9/16', title: 'Día de la Independencia' },
			{ date: '12/25', title: 'Navidad' },
		],
	},
	Ecuador: {
		2024: [{ date: '12/25', title: 'Navidad' }],
		2025: [
			{ 'date': '1/1', 'title': 'Ano Novo' },
			{ 'date': '3/3', 'title': 'Carnaval' },
			{ 'date': '3/4', 'title': 'Carnaval' },
			{ 'date': '4/18', 'title': 'Sexta-feira Santa' },
			{ 'date': '5/1', 'title': 'Dia do Trabalho' },
			{ 'date': '5/24', 'title': 'Batalha de Pichincha' },
			{ 'date': '8/10', 'title': 'Dia da Independência' },
			{ 'date': '10/9', 'title': 'Independência de Guayaquil' },
			{ 'date': '11/2', 'title': 'Dia de Finados' },
			{ 'date': '11/3', 'title': 'Independência de Cuenca' },
			{ 'date': '12/25', 'title': 'Natal' },
		],
	},
	Venezuela: {
		2024: [{ date: '12/25', title: 'Navidad' }],
		2025: [
			{ 'date': '1/1', 'title': 'Ano Novo' },
			{ 'date': '2/3', 'title': 'Carnaval' },
			{ 'date': '2/4', 'title': 'Carnaval' },
			{ 'date': '4/17', 'title': 'Quinta-feira Santa' },
			{ 'date': '4/18', 'title': 'Sexta-feira Santa' },
			{ 'date': '4/19', 'title': 'Declaração de Independência' },
			{ 'date': '5/1', 'title': 'Dia do Trabalho' },
			{ 'date': '6/24', 'title': 'Batalha de Carabobo' },
			{ 'date': '7/5', 'title': 'Dia da Independência' },
			{ 'date': '7/24', 'title': 'Aniversário de Simón Bolívar' },
			{ 'date': '10/12', 'title': 'Dia da Resistência Indígena' },
			{ 'date': '12/25', 'title': 'Natal' },
		],
	},
	'Costa Rica': {
		2024: [
			{ 'date': '12/1', 'title': 'Dia da Abolição do Exército' },
			{ date: '12/25', title: 'Navidad' },
		],
		2025: [
			{ 'date': '1/1', 'title': 'Ano Novo' },
			{ 'date': '4/11', 'title': 'Dia de Juan Santamaría' },
			{ 'date': '4/17', 'title': 'Quinta-feira Santa' },
			{ 'date': '4/18', 'title': 'Sexta-feira Santa' },
			{ 'date': '5/1', 'title': 'Dia do Trabalho' },
			{ 'date': '7/25', 'title': 'Anexação de Guanacaste' },
			{ 'date': '8/2', 'title': 'Dia da Virgem dos Anjos' },
			{ 'date': '8/15', 'title': 'Dia das Mães' },
			{ 'date': '9/15', 'title': 'Dia da Independência' },
			{ 'date': '12/1', 'title': 'Dia da Abolição do Exército' },
			{ 'date': '12/25', 'title': 'Natal' },
		],
	},
}

export function Calendar() {
	const history = useHistory()

	const [year, setYear] = useState(new Date().getFullYear())
	const [yearSelected, setYearSelected] = useState(year)

	const [selectedCountry, setSelectedCountry] = useState(countries[0])

	const selectYear = year => {
		setYearSelected(year)
	}

	/* const handlePreviousYear = () => setYear(year - 1)
	const handleNextYear = () => setYear(year + 1) */

	return (
		<div className='tw-p-5 tw-overflow-auto'>
			<div className='tw-flex tw-items-center tw-gap-4 tw-h-auto tw-mb-5'>
				{/* <FormattedMessage id='backStepEvaluation'>
					{msg => (
						<Link
							title={msg}
							to='/app'
							className='tw-h-8 tw-w-8 tw-bg-purple-500 tw-text-white tw-rounded-full tw-flex tw-items-center tw-justify-center hover:tw-bg-white hover:tw-text-purple-500'
							style={{ border: '2px solid #7a6be8' }}
						>
							<HiArrowSmallLeft size={22} />
						</Link>
					)}
				</FormattedMessage> */}
				<FormattedMessage id='backStepEvaluation'>
					{msg => (
						<button
							title={msg}
							className='tw-h-8 tw-w-8 tw-bg-purple-500 tw-text-white tw-rounded-full tw-flex tw-items-center tw-justify-center hover:tw-bg-white hover:tw-text-purple-500'
							style={{ border: '2px solid #7a6be8' }}
							onClick={() => {
								history.go(-1)
							}}
						>
							<HiArrowSmallLeft size={22} />
						</button>
					)}
				</FormattedMessage>
				<h1 className='tw-font-bold tw-text-xl tw-p-0 tw-m-0'>Calendario</h1>
			</div>
			<div className='tw-flex tw-items-center tw-space-x-4'>
				{/* <button onClick={handlePreviousYear} className='tw-bg-gray-200 tw-rounded-md tw-px-2 tw-py-1 border-0 tw-text-gray-600'>
					&lt;
				</button> */}

				<button
					className={`tw-px-4 tw-py-1 tw-rounded-md border-0 ${
						year === yearSelected ? 'tw-bg-purple-500 tw-text-white' : 'tw-bg-gray-100 tw-text-gray-500'
					}`}
					onClick={() => selectYear(year)}
				>
					{year}
				</button>
				<button
					className={`tw-px-4 tw-py-1 tw-rounded-md border-0 ${
						year + 1 === yearSelected ? 'tw-bg-purple-500 tw-text-white' : 'tw-bg-gray-100 tw-text-gray-500'
					}`}
					onClick={() => selectYear(year + 1)}
				>
					{year + 1}
				</button>

				{/* <button onClick={handleNextYear} className='tw-bg-gray-200 tw-rounded-md tw-px-2 tw-py-1 border-0 tw-text-gray-600'>
					&gt;
				</button> */}

				<select
					className='border tw-border-gray-500 tw-rounded-md tw-px-4 tw-py-1 tw-bg-white'
					value={selectedCountry}
					onChange={e => setSelectedCountry(e.target.value)}
				>
					{countries.map((country, index) => (
						<option key={index} value={country}>
							{country}
						</option>
					))}
				</select>
			</div>
			<div className='tw-flex tw-flex-col desktop:tw-flex-row border tw-rounded-lg tw-p-4 tw-mt-4 tw-h-[calc(100vh_-_210px)] tw-overflow-auto'>
				<div className='tw-w-full tw-flex tw-flex-wrap tw-gap-2 desktop:tw-pr-8'>
					{[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(item => (
						<Mouth month={item} year={yearSelected} key={item} holidays={holiDays[selectedCountry][yearSelected]} />
					))}
				</div>
				<div className='desktop:tw-w-[380px] desktop:tw-h-[calc(100vh_-_245px)] tw-flex-none tw-relative'>
					<HolidayList holidays={holiDays[selectedCountry][yearSelected]} />
				</div>
			</div>
		</div>
	)
}
